(function () {
  function applyEditableMenu(root) {
    var searchRoot = root && root.querySelectorAll ? root : document;
    var menus = searchRoot.querySelectorAll('[data-raev-editable-menu]');

    menus.forEach(function (menu) {
      var items = Array.prototype.slice.call(
        menu.querySelectorAll('.menu-drawer__menu.has-submenu > .menu-drawer__list-item')
      );

      items.forEach(function (item, index) {
        if (index >= 3) item.hidden = true;
      });

      for (var index = 0; index < 3; index += 1) {
        var item = items[index];
        if (!item) continue;

        var position = index + 1;
        var label = menu.getAttribute('data-menu-label-' + position) || '';
        var url = menu.getAttribute('data-menu-url-' + position) || '';
        var link = item.querySelector(':scope > a.menu-drawer__menu-item--mainlist');
        var summary = item.querySelector(':scope > details > summary.menu-drawer__menu-item');
        var target = link || summary;

        if (!target || !label.trim()) {
          item.hidden = true;
          continue;
        }

        item.hidden = false;
        var text = target.querySelector('.menu-drawer__menu-item-text');
        if (text && text.textContent !== label) text.textContent = label;
        if (link && url && link.getAttribute('href') !== url) link.setAttribute('href', url);
      }
    });
  }

  function initialize() {
    applyEditableMenu(document);
    window.requestAnimationFrame(function () {
      applyEditableMenu(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyEditableMenu(event.target);
  });

  document.addEventListener('shopify:section:select', function () {
    applyEditableMenu(document);
  });

  document.addEventListener('shopify:block:select', function () {
    applyEditableMenu(document);
  });
})();
